import React from "react";

const FleetDetails = ({ data = [] }) => {
    return (
        <div className="bg-white rounded-lg shadow p-4 h-96 flex flex-col">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Fleet Details</h2>

            {/* Scrollable Table Container */}
            <div className="overflow-y-auto overflow-x-auto flex-1 border border-gray-200 rounded-lg">
                <table className="w-full">
                    <thead className="bg-[#1467B3] text-white sticky top-0 z-10">
                        <tr>
                            <th className="px-4 py-3 text-left font-semibold">LOB</th>
                            <th className="px-4 py-3 text-left font-semibold">PPL</th>
                            <th className="px-4 py-3 text-left font-semibold">PL</th>
                            <th className="px-4 py-3 text-left font-semibold">Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, index) => (
                                <tr
                                    key={index}
                                    className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                                >
                                    <td className="px-4 py-3 text-gray-700">{row.LOB}</td>
                                    <td className="px-4 py-3 text-gray-900 font-semibold">{row.PPL}</td>
                                    <td className="px-4 py-3 text-gray-700">{row.PL}</td>
                                    <td className="px-4 py-3 text-gray-700">{row.Count}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan="4"
                                    className="px-4 py-3 text-center text-gray-500"
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FleetDetails;
